import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './Footer.styled';
import { setColorWithOpacityCss } from '../../utils/setColorWithOpacityCss';
import { NextImg } from '../../atoms/NextImg';
import { FacebookShare, XShare, InstagramShare, LinkedinShare, ArrowUpward } from '../../svgs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const socialsMap = {
  facebook: /*#__PURE__*/_jsx(FacebookShare, {
    fill: "currentcolor"
  }),
  twitter: /*#__PURE__*/_jsx(XShare, {
    fill: "currentcolor"
  }),
  instagram: /*#__PURE__*/_jsx(InstagramShare, {
    fill: "currentcolor"
  }),
  linkedin: /*#__PURE__*/_jsx(LinkedinShare, {
    fill: "currentcolor"
  })
};
const scrollToTop = () => {
  if (typeof window === 'undefined') return false;
  return window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
/**
 * The `Footer` content block renders a standardized page footer with the organizations
 * information, including social media buttons.
 */
export const Footer = ({
  logoAssetUrl,
  logoAltText = '',
  openLinksInNewTab = true,
  links = [],
  cssColor,
  cssBackgroundColor,
  cssBackgroundColorOpacity,
  footer,
  NextImage,
  ...rest
}) => {
  const {
    t
  } = useTranslation('blocks.footer');
  const campaignName = footer?.name || '';
  return /*#__PURE__*/_jsxs(Styled.FooterSection, {
    "data-id": "cp-footer",
    cssColor: cssColor,
    cssBackgroundColor: setColorWithOpacityCss(cssBackgroundColor, cssBackgroundColorOpacity),
    ...rest,
    children: [/*#__PURE__*/_jsxs(Styled.DetailsContainer, {
      children: [logoAssetUrl && /*#__PURE__*/_jsx(NextImg, {
        NextImage: NextImage,
        priority: false,
        src: logoAssetUrl,
        alt: logoAltText,
        height: "600",
        width: "600"
      }), /*#__PURE__*/_jsx("div", {
        children: footer?.name
      }), /*#__PURE__*/_jsx("div", {
        children: footer?.address
      }), /*#__PURE__*/_jsxs("div", {
        children: [footer?.city, ", ", footer?.state, " ", footer?.postalCode, " ", footer?.country]
      }), footer?.privacyPolicyUrl && /*#__PURE__*/_jsx(Styled.PrivacyPolicyLink, {
        "data-id": "cp-footer-privacy-policy",
        href: footer.privacyPolicyUrl,
        target: openLinksInNewTab ? '_blank' : undefined,
        children: t('Footer.campaignPrivacyPolicyLink', {
          campaignName,
          defaultValue: 'Privacy Policy'
        })
      }), /*#__PURE__*/_jsx(Styled.SocialsContainer, {
        children: links.map(({
          social,
          url
        }) => /*#__PURE__*/_jsx(Styled.SocialLink, {
          "data-id": `cp-footer-${social}`,
          "aria-label": social === 'twitter' ? 'x' : social,
          href: url,
          target: openLinksInNewTab ? '_blank' : undefined,
          children: socialsMap[social]
        }, social))
      })]
    }), /*#__PURE__*/_jsxs(Styled.ContactContainer, {
      children: [/*#__PURE__*/_jsx("div", {
        children: t('Footer.donorSupportLabel', 'Donor Support')
      }), /*#__PURE__*/_jsx("a", {
        href: `mailto:${footer?.email}`,
        children: footer?.email
      }), footer?.phone && /*#__PURE__*/_jsx("a", {
        href: `tel:${footer?.phone}`,
        children: footer?.phone
      })]
    }), /*#__PURE__*/_jsxs(Styled.BackToTop, {
      onClick: scrollToTop,
      children: [/*#__PURE__*/_jsx(ArrowUpward, {
        fill: "currentcolor"
      }), t('Footer.backToTopButton', 'Back to top')]
    })]
  });
};